"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var bulk_field_menu_html_1 = __importDefault(require("./bulk-field-menu.html"));
(function (module) {
    var PAGINATION_LIMIT = 20;
    function BulkFieldMenuController($q, $scope, bulkFieldService, fieldsetService, $filter) {
        var $ctrl = this;
        $scope.$ctrl = $ctrl;
        var bulkFieldOptions = bulkFieldService.getConfig();
        if (!_.get(bulkFieldOptions, 'fieldId')) {
            return;
        }
        angular.extend($ctrl, {
            bulkFieldValue: bulkFieldOptions.value,
            pagination: {
                limit: PAGINATION_LIMIT
            },
            $onInit: function () {
                initLabel();
            },
            getMenuItems: function getMenuItems() {
                return bulkFieldService.getDomain().then(function (domainEntries) {
                    return $q.all([null].concat(domainEntries).map(function (domainEntry) {
                        return getLabel(domainEntry).then(function (label) {
                            var value = _.isObject(domainEntry) ? domainEntry.value : domainEntry;
                            return {
                                label: label,
                                value: value,
                                selected: value === $ctrl.bulkFieldValue,
                                action: function () {
                                    bulkFieldService.setValue(value);
                                    $ctrl.bulkFieldValue = value;
                                    $ctrl.bulkFieldLabel = label;
                                }
                            };
                        });
                    }));
                });
            }
        });
        function initLabel() {
            if ($ctrl.bulkFieldValue) {
                bulkFieldService.getDomain().then(function (domainEntries) {
                    var entry = _.find(domainEntries, { value: $ctrl.bulkFieldValue });
                    return getLabel(entry).then(function (label) {
                        $ctrl.bulkFieldLabel = label;
                    });
                });
            }
            else {
                getLabel(null).then(function (label) {
                    $ctrl.bulkFieldLabel = label;
                });
            }
        }
        function getLabel(domainEntry) {
            if (!domainEntry) {
                return $q.when($filter('translate')('NONE'));
            }
            else if (domainEntry.label) {
                return $q.when(domainEntry.label);
            }
            var value = _.isObject(domainEntry) ? domainEntry.value : domainEntry;
            return fieldsetService.getFieldsetBySourceId(bulkFieldOptions.sourceId).then(function (fieldset) {
                var label = _.get(fieldset, ['labels', bulkFieldOptions.fieldId, value]);
                return _.isUndefined(label) ? value : label;
            }).catch(function (error) {
                console.error('Error getting field label for bulk field dropdown', error);
                return value;
            });
        }
    }
    BulkFieldMenuController.$inject = [
        '$q',
        '$scope',
        'pr.bulkFieldService',
        'prFieldsets',
        '$filter'
    ];
    module.component('prBulkFieldMenu', {
        controller: BulkFieldMenuController,
        templateUrl: bulk_field_menu_html_1.default,
        require: {
            fbCtrl: '^^prFilebar'
        },
    });
}(angular.module('qualtrics.pr')));
